<template>
  <div class="order_detail_page">
    <div class="site_info_header">
      <div class="site_name">喜乐 {{ detailsdata.site_name }}</div>
      <div class="site_id">站号：{{ detailsdata.site_id }}</div>
    </div>

    <div class="success_card">
      <div class="status_indicator" :class="{ 'error': !details_complete }">
        <span class="iconfont" :class="details_complete ? 'icon-duihao' : 'icon-cuo'"></span>
      </div>
      <div class="operation_result">{{ details_complete ? '操作成功' : '操作失败' }}</div>
      
      <div class="order_summary">
        <div class="oil_type">{{ detailsdata.oil_name }}</div>
        <div class="oil_amount">{{ detailsdata.num }}<small> 升</small></div>
      </div>

      <div class="detail_list">
        <div class="detail_item" v-if="detailsdata.order_type==3">
          <span class="detail_label">单价</span>
          <span class="detail_value">￥{{ detailsdata.total_money }}</span>
        </div>
        <div class="detail_item">
          <span class="detail_label">车牌号</span>
          <span class="detail_value">{{ detailsdata.car_number }}</span>
        </div>
        <div class="detail_item">
          <span class="detail_label">下单时间</span>
          <span class="detail_value">{{ detailsdata.create_time }}</span>
        </div>
      </div>
    </div>

    <div class="action_area">
      <div class="primary_btn" @click="goHome">返回首页</div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import wx from "weixin-js-sdk";

export default {
  name: "orderDetail",
  data() {
    return {
      detailsdata: "",
      details_complete: true,//订单是否完成
      token: ""
    }
  },
  methods: {
    goHome() {
      this.$router.replace("/");
    }
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    let url = 'wx/orderDetail';
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
    } else if (this.$router.currentRoute.query.app_id == "xiangmeng") {
      this.app_id = this.$router.currentRoute.query.app_id;
      url = 'wx/putbox/orderDetail';
    } else {
      this.$router.replace({name: 'login'});
    }
    let order_id = this.$router.currentRoute.params.order_id;
    let token = this.token;
    let querystring = require('querystring');
    this.$api.post(url,
        querystring.stringify({
          order_id,
          token
        })
    ).then(data => {
      if (data.data.status == 1) {
        this.detailsdata = data.data.data;
      } else {
        this.details_complete = false;
        common.toast(data.data.msg);
      }
    }).catch(err => {
      console.log(err);
    })
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: res => {
        let querystring = require('querystring');
        this.$api.post('wx/User/getLocation',
            querystring.stringify({
              latitude: res.latitude,
              longitude: res.longitude,
              token: token,
              action: "order_detail",
            })
        )
      }
    });
  }
}
</script>

<style scoped>
.order_detail_page {
  width: 100vw;
  min-height: 100vh;
  background-color: #f6f8fa;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.site_info_header {
  background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
  padding: 30px 20px 60px;
  color: white;
  text-align: center;
}

.site_name {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.site_id {
  font-size: 13px;
  opacity: 0.8;
}

.success_card {
  background: white;
  margin: -30px 20px 0;
  border-radius: 20px;
  padding: 30px 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.status_indicator {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #e7f5ff;
  color: #106EBE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.status_indicator.error {
  background: #fff5f5;
  color: #fa5252;
}

.status_indicator .iconfont {
  font-size: 40px;
}

.operation_result {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
}

.order_summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
  width: 100%;
  padding: 20px 0;
  background: #f8f9fa;
  border-radius: 12px;
}

.oil_type {
  font-size: 14px;
  color: #868e96;
  font-weight: 600;
}

.oil_amount {
  font-size: 32px;
  font-weight: 800;
  color: #106EBE;
}

.oil_amount small {
  font-size: 16px;
  font-weight: 600;
}

.detail_list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.detail_label {
  color: #adb5bd;
}

.detail_value {
  color: #495057;
  font-weight: 600;
}

.action_area {
  padding: 40px 20px;
}

.primary_btn {
  width: 100%;
  height: 54px;
  background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
  color: white;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 8px 20px rgba(16, 110, 190, 0.2);
  transition: all 0.2s;
}

.primary_btn:active {
  transform: scale(0.98);
  box-shadow: 0 4px 10px rgba(16, 110, 190, 0.1);
}
</style>
    


// WEBPACK FOOTER //
// src/components/orderDetail.vue